module.exports = KsysAppTemplateV2dot59dot0;